import * as React from 'react';
import { useTranslation } from 'react-i18next';

const Loading = () => {
	const { t } = useTranslation();

	return (
		<div id="Loading" className="page1 noAnimate">
			<div className="wrapper">
				<div className="loadingLayout">
					<p>{t('Loading')}...</p>
					<div className="meter">
						<span>
							<span className="progressAnimated"></span>
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default React.memo(Loading);
